import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Modal, Input } from 'hljd'
import { observer } from 'mobx-react'
import Upload from '../../Upload'
import LabelText from '../../cards/LabelText'
import { dGet } from '@core/utils'
import { Exhibition } from 'hlj-components'
import columns from './columns'
import style from './style.module.less'

const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 }
}

@Form.create()
@observer
export default class extends Component {
  submit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.store.applyRefund({
          ...values,
          refund_attachments: JSON.stringify(values.refund_attachments)
        })
      }
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const {
      applyReturnFeeModalVisible,
      setStoreData,
      currentBrokerageOrder
    } = this.props.store
    const { merchant } = currentBrokerageOrder

    return (
      <Modal
        title="申请退还服务费"
        visible={applyReturnFeeModalVisible}
        onOk={this.submit}
        onCancel={() =>
          setStoreData([{ type: 'applyReturnFeeModalVisible', value: false }])
        }
        width={600}
      >
        <LabelText label="商家名" block>
          {dGet(merchant, 'name')}
        </LabelText>

        <div className={style.exhibition}>
          <Exhibition columns={columns} data={currentBrokerageOrder} />
        </div>

        <Form>
          <Form.Item {...formItemLayout} label="退款原因：">
            {getFieldDecorator('refund_remark', {
              initialValue: '',
              rules: [
                {
                  required: true,
                  message: '请输入退款原因'
                }
              ]
            })(<Input placeholder="请输入" />)}
          </Form.Item>
        </Form>

        <div style={{ marginTop: 10 }}>
          {getFieldDecorator('refund_attachments', {
            initialValue: []
          })(<Upload />)}
        </div>
      </Modal>
    )
  }
}
